import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Plans from "./pages/Plans";
import Payment from "./pages/Payment";
import Resume from "./pages/Resume";
import Subscription from "./pages/Subscription";
import ChangePayment from "./pages/ChangePayment";
import Billings from "./pages/Billings";
import ProtectedRoute from "./components/ProtectedRoute";

const MyRoutes = () => {
    return (
        <Router>
            <Routes>
                {/* Rotas Públicas */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/recuperar-senha" element={<ForgotPassword />} />
                <Route path="/redefinir-senha" element={<ResetPassword />} />

                {/* Rotas Protegidas - Requerem Autenticação */}
                <Route
                    path="/selecione-plano"
                    element={
                        <ProtectedRoute>
                            <Plans />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/pagamento"
                    element={
                        <ProtectedRoute>
                            <Payment />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/resumo"
                    element={
                        <ProtectedRoute>
                            <Resume />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/minha-assinatura"
                    element={
                        <ProtectedRoute>
                            <Subscription />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/alterar-pagamento"
                    element={
                        <ProtectedRoute>
                            <ChangePayment />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/minhas-faturas"
                    element={
                        <ProtectedRoute>
                            <Billings />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Router>
    )
}

export default MyRoutes;